<script lang="ts">
  /** Where a claim came from: a numbered footnote for `public`, a tag otherwise.
   *  Never both — a reader who sees a tag knows no public source backs the line. */
  import type { Provenance, RenderCtx } from './types';

  let { provenance, sourceIds = [], ctx }: {
    provenance?: Provenance;
    sourceIds?: string[];
    ctx: RenderCtx;
  } = $props();

  const notes = $derived(
    provenance === 'public'
      ? sourceIds
          .map(id => ({ id, n: ctx.footnotes.get(id) }))
          .filter((x): x is { id: string; n: number } => x.n !== undefined)
      : [],
  );
</script>

{#if provenance === 'public'}{#each notes as note, i (note.id)}<a
  class="brf-fn" class:cont={i > 0} href="#{ctx.idPrefix}-{note.id}"
  aria-label="Source {note.n}" title={ctx.sources.find(s => s.id === note.id)?.label}
  onclick={(event) => { event.preventDefault(); ctx.onFootnote?.(note.id); }}>{note.n}</a>{/each}{:else if provenance === 'relationship'}<span
  class="brf-tag rel">Relationship</span>{:else if provenance === 'inference'}<span
  class="brf-tag inf">Inference</span>{/if}
